import {ObjectMeterCheckAssoc} from "../../../model/object-meter-check-assoc";
import {otsBaseApi} from "../../ots-api";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['ObjectMeterCheckAssocs']})

const objectMeterCheckAssocApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getObjectMeterCheckAssocsByMeter: builder.query<ObjectMeterCheckAssoc[], string>(
      {
        query: (meterId) => ({
          url: `/object-meter-check-assocs/meter/${meterId}`,
          method: 'GET',
        }),
        providesTags: (result) => {
          if (result) {
            return [
              ...result.map(
                ({id}) => ({type: 'ObjectMeterCheckAssocs', id} as const)
              ),
              {type: 'ObjectMeterCheckAssocs', id: 'LIST'},
            ];
          } else {
            return [{type: 'ObjectMeterCheckAssocs', id: 'LIST'}];
          }
        },
      }
    ),
    getObjectMeterCheckAssoc: builder.query<ObjectMeterCheckAssoc, string>({
      query: (id) => ({
        url: `/object-meter-check-assocs/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{type: 'ObjectMeterCheckAssocs', id}],
    }),
    createObjectMeterCheckAssoc: builder.mutation<void, Partial<ObjectMeterCheckAssoc>>({
      query: (mapping) => ({
        url: '/object-meter-check-assocs',
        method: 'POST',
        body: mapping,
        responseHandler: () => Promise.resolve(),
      }),
      invalidatesTags: [{type: 'ObjectMeterCheckAssocs', id: 'LIST'}],
    }),
    updateObjectMeterCheckAssoc: builder.mutation<void, Partial<ObjectMeterCheckAssoc>>({
      query: (mapping) => ({
        url: '/object-meter-check-assocs',
        method: 'PUT',
        body: mapping,
        responseHandler: () => Promise.resolve(),
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: 'ObjectMeterCheckAssocs', id},
      ],
    }),
    deleteObjectMeterCheckAssoc: builder.mutation<void, Partial<ObjectMeterCheckAssoc>>({
      query: (mapping) => ({
        url: `/object-meter-check-assocs/${mapping.id}`,
        method: 'DELETE',
        body: mapping,
        responseHandler: () => Promise.resolve(),
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: 'ObjectMeterCheckAssocs', id},
      ],
    }),
  }),
})

export const {
  useGetObjectMeterCheckAssocsByMeterQuery,
  useGetObjectMeterCheckAssocQuery,
  useCreateObjectMeterCheckAssocMutation,
  useUpdateObjectMeterCheckAssocMutation,
  useDeleteObjectMeterCheckAssocMutation,
} = objectMeterCheckAssocApi;
